/**
 * Dates like issue, expiry, due and birth dates are stored as plain
 * "YYYY-MM-DD" with no time. `new Date("2030-12-30")` reads that as midnight
 * UTC, which in Pacific time is the evening of Dec 29 -- so the app showed
 * every such date one day early. Read them as a local calendar date instead.
 * Full timestamps (anything with a time) are parsed as usual.
 */
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export function parseDateOnly(value: string): Date {
  if (DATE_ONLY.test(value)) {
    const [y, m, d] = value.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  return new Date(value);
}

export function formatDateOnly(
  value: string,
  locales?: Intl.LocalesArgument,
  options?: Intl.DateTimeFormatOptions
): string {
  return parseDateOnly(value).toLocaleDateString(locales, options);
}
